import offerImage from './img/sweepstakes/xbox/320x180.jpg'
import SweepstakesBasePage from './SweepstakesBasePage'

const Page: React.FC = () => {
  return <SweepstakesBasePage optionsId={''} funnelName="xbox" offerImage={offerImage} offerTitle="XBox Series X" />
}

export default Page
